import { getPastSrApi } from "@services/MarketWorking/MyTeam/getPastSrApi";
import {
  GET_PASTINSIGHTS_DETAILS_FAIL,
  GET_PASTINSIGHTS_DETAILS_SUCCESS,
} from "../constants/action-types";
import { setAlert } from "./alert-action";
import { sessionExpireTimeout } from "./utility-actions";

export const getPastSrDetails = () => async (dispatch) => {
  const response = await getPastSrApi();
  if (response?.status === 200) {
    dispatch({
      type: GET_PASTINSIGHTS_DETAILS_SUCCESS,
      payload: response?.data,
    });
  } else if (response?.error === "ERR_NETWORK") {
    sessionExpireTimeout(dispatch);
  } else {
    dispatch({
      type: GET_PASTINSIGHTS_DETAILS_FAIL,
    });
    dispatch(setAlert(response?.error, "error"));
  }
};
